window.Vue = require('vue');

export class NoticeService {

    constructor() {
        this.notices = null;
        this.loading = false;
    }

    getNotices() {

        let result = this.notices;
        if (!this.notices) {
            this.loadNotices();
            result = this.notices;
        }

        return result;
    }

    setNotices(notices) {
        this.notices = notices;
        bus.$emit('notices:added', notices);
    }

    loadNotices() {
        // Makes sure only one request per load is send.
        if (true === this.loading) {
            return;
        }

        this.loading = true;

        bus.$emit('notices:loading');
        axios.get('/api/shop/notices')
            .then(response => {
                bus.$emit('notices:loaded', response.data);
                this.setNotices(response.data);
                this.loading = false;
            });
    }
}
